<template>
  <div>
    <v-navigation-drawer permanent mini-variant right 
       :fixed="$vuetify.breakpoint.mdAndUp"
        mini-variant-width="50"
        class="icon-tray-drawer float-right" color="transparent" >
      <v-list rounded>
        <v-list-item v-for="item in tabItems" :key="item.title" @click="displaySection(item)"
           class="px-1 py-3">
          <v-list-item-icon class="ma-0">
            <v-tooltip left>
              <template v-slot:activator="{ on, attrs }">
                <v-icon :color="activeSection==item.id ? '#06B6FC' : ''" v-bind="attrs" v-on="on">
                  {{ item.icon }}</v-icon>
              </template>
              <span>{{item.title}}</span>
            </v-tooltip>
          </v-list-item-icon>
        </v-list-item>
      </v-list>
    </v-navigation-drawer>
    <div class="ml-2 mr-8">
      <customer-info v-show="activeSection == 'customer'" :ticketDetails="ticketDetails"></customer-info>
    </div>
  </div>
</template>

<script>
import CustomerInfo from "@/components/tickets/CustomerInfo.vue";
import { mapGetters } from "vuex";

export default {
  name: "ticket-right-side-section",
  props: {
    ticketDetails: {
      type: Object,
      default: ()=> ({})
    },
    ticketAccess: {
      type: Object,
      default: ()=> ({})
      }
  },
  components: {
    CustomerInfo
  },

  data() {
    return {
      ticketId: this.$route.params.id,
      activeSection:'customer',
      rightSidePanel: [0, 1],
      items: [
        { title: 'Customer info', icon: 'mdi-account-box-outline', id:"customer" },
        { title: 'Tags', icon: 'mdi-tag-outline', id:"tags" },
        { title: 'Customer orders', icon: 'mdi-package-variant-closed', id:"orders" },
        { title: 'Threads', icon: 'mdi-message-text-fast-outline', id:"threads" },
      ],
    }
  },

  computed:{
    ...mapGetters({
      account: ["auth/account"],
    }),
    tabItems () {
      return this.items.filter(item => !(item.id === 'orders' && this.ticketAccess.deleted));
    },
  },

  methods: {
    displaySection(item) {
      this.activeSection = item.id === 'customer' ? item.id : null;
      if (this.activeSection !== 'customer') {
        this.$emit("showSection", item.id);
      }
    }
  }

}
</script>

<style scoped lang="scss">
 .icon-tray-drawer{
    top: 255px !important;
    right: 5px;
    z-index: 1;
    .active-list{
        color: aqua;
    }
    .v-list-item{
        min-height: 0px !important;
    }
    .v-list-item--active {
      color: #06B6FC !important;
    }
 }
</style>
